import React from 'react';

function WithoutConsent({ color = '#335B70', ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
            <path
                d="M7.425 11.625 9 10.05l1.575 1.575 1.05-1.05L10.05 9l1.575-1.575-1.05-1.05L9 7.95 7.425 6.375l-1.05 1.05L7.95 9l-1.575 1.575zM9 16.5q-2.606-.656-4.303-2.99T3 8.324V3.75L9 1.5l6 2.25v4.575q0 2.85-1.697 5.184Q11.607 15.844 9 16.5m0-1.575q1.95-.62 3.225-2.475A7.12 7.12 0 0 0 13.5 8.325V4.781L9 3.094 4.5 4.78v3.544q0 2.27 1.275 4.125Q7.05 14.307 9 14.925"
                fill={color}
            />
        </svg>
    );
}

export default WithoutConsent;
